import React, { forwardRef } from "react";
import { Element } from "react-scroll";

import { transparentGray, white } from "./base/colors";
import Button from "./base/button";
import Flex from "./base/flex";
import Box from "./base/box";
import Image from "./base/image";
import LoadingSpinner from "./base/loading-spinner";

import Plus from "../images/plus.svg";

import { useContentContext } from "../context/content-context";

const ISISection = forwardRef(({ isInView, ISIScrollButton }, ref) => {
  const { isi, isHCP } = useContentContext();
  const content = isi
    ?.split("</section>")
    .map((string) => string + "</section>");

  const sidebarContent = content?.[0];
  const mainContent = content?.[1];

  return (
    <Element name="isi-section">
      <Box ref={ref} height="382px" />

      <Flex
        height={isInView ? "unset" : ["217px", "191px", "191px"]}
        position={isInView ? "relative" : "fixed"}
        bottom={0}
        padding={
          isInView && !isHCP
            ? ["50px 25px 50px", "50x 33px 50px", "50px 0 50px"]
            : ["25px 25px 32px", "25px 33px 32px", "25px 0 20px"]
        }
        justifyContent="center"
        marginTop="-382px"
        width="100%"
        boxShadow={isInView ? "none" : `0px -3px 6px ${transparentGray}`}
        backgroundColor={white}
        zIndex={3}
      >
        {!isi ? (
          <Flex height="166px" alignItems="center">
            <LoadingSpinner />
          </Flex>
        ) : (
          <Flex
            maxWidth="1200px"
            position="relative"
            justifyContent="space-between"
            flexDirection={
              isInView ? ["column", "column", "row"] : ["column", "row", "row"]
            }
          >
            <Box
              width={
                isInView
                  ? ["100%", "100%", "calc(33% - 31px)"]
                  : ["100%", "calc(50% - 8px)", "calc(33% - 31px)"]
              }
              marginBottom={["30px", "30px", 0]}
            >
              <div dangerouslySetInnerHTML={{ __html: sidebarContent }} />
            </Box>
            <Box
              width={
                isInView
                  ? ["100%", "100%", "calc(66% - 7px)"]
                  : ["100%", "calc(50% - 8px)", "calc(66% - 7px)"]
              }
            >
              <div dangerouslySetInnerHTML={{ __html: mainContent }} />
            </Box>
            {!isInView && (
              <Button
                as="div"
                variant="unstyled"
                position="absolute"
                right={0}
                height={25}
              >
                <ISIScrollButton>
                  <Image alt="Expand button" src={Plus} />
                </ISIScrollButton>
              </Button>
            )}
          </Flex>
        )}
      </Flex>
    </Element>
  );
});

export default ISISection;
